module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter Introduction",
    attrs: {
      "id": "section_introduction--num_1--seq_4"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_66182-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_vii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_vii"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_66182-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_vii"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674470_tableofcontents"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_66182-00001"
    }
  }, [_vm._v("Two of the greatest twentieth-century British poets of place, Ted Hughes and W. H. Auden, resembled the landscapes they loved. One thinks of Hughes’s great granitic head, more tor than skull, and of the Auden of the 1960s, his face deeply creased and grooved laterally, like the limestone pavements of Yorkshire in which much of his poetry is grounded.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_66182-00002"
    }
  }, [_vm._v("John Muir also grew into likeness with his chosen terrain. The most famous photograph of the elder Muir – the guardian of Yosemite, the family man, the esteemed essayist and memoirist – shows him in profile, seated on a boulder of his cherished Californian granite. The tones of his shirt and the colour of his beard rhyme with the pale grey of the rock beneath him. Heis part Victorian patriarch, part geological extrusion.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_66182-00003"
    }
  }, [_vm._v("Muir (1838–1914) himself never knew quite what he was, and it delighted him not to know. ‘I am a poetico-trampo-geologist-bot. and ornith-natural, etc.!!!’ he wrote gleefully to a friend in 1873. Looking back over his long life, one sees why he had to weld together such a compound description of himself – for there are so many John Muirs.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_66182-00005"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_viii"
    }
  }, [_vm._v("There is Muir the long-distance tramp, vagabondising a thousand miles from Indianapolis to the Gulf of Mexico. There is Muir the mountaineer, stalking the high ridges of the Sierra Nevada range in California, and making the first ascents of several of its biggest peaks. There is Muir the geologist, decoding the glacial origins of the Yosemite Valley. There is Muir the explorer, opening up unmapped regions of Alaska in his fifties and living with Native American peoples. There is Muir the botanist, striding through the pollinous bee-meadows of the Sierra, counting the ten thousand flower-heads in a square yard of sub-alpine pasture, and worshipping in the crypt-light of the sequoia groves. There is Muir the activist, successfully lobbying Congress for the creation of a National Park in the Yosemite region. And there is, of course, Muir the nature writer, finessing a prose style which, more purely and ringingly than any other, communicates the "), _c('i', [_vm._v("joy")]), _vm._v(" of being out of doors.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_viii"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_66182-00006"
    }
  }, [_vm._v("In Britain at least, John Muir usually crops up as the third name in a sentence that includes Ralph Waldo Emerson and Henry David Thoreau. Too often, Muir is tucked away like this – lost in the pockets of the two great American sages of nature. True, his environmental metaphysics were less instantly complex than those of Emerson or Thoreau. And in some ways he followed their leads. But his soul was tingled by landscape in ways which Thoreau’s and Emerson’s never were, and it is his ability to communicate this tingle that makes him, to my mind, at least as important as either of his predecessors.")])]), _c('p', {
    attrs: {
      "id": "rw-p_66182-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_viii"
    }
  }, [_vm._v("Reading Emerson’s essays, the natural world comes at you deodorised and desensitised – insulated behind the double-glazing of logic and rhetoric. Muir’s prose, by contrast, is a ")]), _c('a', {
    attrs: {
      "id": "pb-rw_ix"
    }
  }, [_vm._v("miracle of immediacy. His books (many of which were not published until late in his life) have none of the elegiac and crepuscular quality of much memoir. They are illuminated by sunshine and starlight. The cold mineral air of the mountains and the resiny reek of coniferous forests lift bracingly off his pages. No other writer is so ceaselessly astonished by the natural world as Muir, or communicates that astonishment more urgently. Muir lived – as he put it in a typically lovely phrase – ‘in an infinite storm of beauty’, and his readers live in it with him.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_ix"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_66182-00008"
    }
  }, [_vm._v("In North America, Muir has achieved the status of prophet. He is conventionally referred to as the ‘Father of the National Parks’. A "), _c('i', [_vm._v("Time Magazine")]), _vm._v(" survey elected him as one of the hundred Men of the Millennium for the revolution he had brought about in environmental thought. He founded the Sierra Club, which now has over 600,000 members and is perhaps the most formidable environmental pressure group in the States. So many peaks, lakes and glaciers have been named after Muir that the US Geological Survey has been obliged to issue a statement declaring that they would ‘not be likely to approve any further such commemorations’. Three plants, a butterfly, a mineral have been christened in his honour, as well as – rather less appropriately – a touring musical and the John Muir Parkway, a four-lane freeway in Martinez, California, off which tired travellers can pull into the Best Western John Muir Inn. Apparently the beds there are not constructed according to Muir’s favourite specifications: storm-felled branches for a frame, ‘crinkled’ pine-needles for a mattress, and a rock for a pillow.")])]), _c('p', {
    attrs: {
      "id": "rw-p_66182-00009"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_ix"
    }
  }, [_vm._v("Muir’s reputation in Britain, the country of his birth – in ")]), _c('a', {
    attrs: {
      "id": "pb-rw_x"
    }
  }, [_vm._v("Dunbar, East Lothian, third child of a fiercely Presbyterian farmer and lay preacher called Daniel Muir – is less secure, and his influence less ubiquitous, though we need him now more than ever.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_x"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_66182-00010"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_x"
    }
  }, [_vm._v("‘Wildness’, wrote Muir in 1875, ‘is a necessity; and mountain parks and reservations are useful not only as fountains of timber and irrigating rivers, but as fountains of life.’ This was the insight he bequeathed to late modernity: that a landscape might be valuable not in terms of the economic or agrarian resources it provides, but in terms – harder to measure, harder to prove – of its profound spiritual effect. In the words of one of Muir’s epigones, the American novelist and essayist Wallace Stegner, ‘we simply need … wild country available to us, even if we never do more than drive to its edge and look in. For it can be a means of reassuring ourselves of our sanity as creatures, a part of the geography of hope.’"), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-0",
      "id": "num-footnote-1-0-back"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_66182-00001"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_66182-00002"
    }
  }, [_vm._v("Like all those who survive posterity’s prolific deletions, John Muir’s life has the outline of a myth. At least the way he told it, he underwent a spiritual conversion at the hands of nature. In the course of a single remarkable summer – his first summer in the Sierra – Muir was transformed from the son of a preacher-man to a child of nature.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_66182-00011"
    }
  }, [_vm._v("In 1849, when Muir was eleven, his family moved from Scotland to Wisconsin in search of a new life as farmers. Trying to ripen arable land out of the Wisconsin earth was arduous work, and until he was twenty-one, Muir laboured on the farm. Time was managed with strict parsimony by his Calvinist father (the family rose early, worked all day, and went to sleep immediately after evening prayers), who also imposed a ruthless sabbatarianism. Daniel would regularly thrash his children in the belief that he was ‘beating the devil out of them’.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_66182-00013"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xi"
    }
  }, [_vm._v("When he was fifteen, Muir was set the task of excavating a well in the sandstone rock on which the farm stood. For several months, every day except Sundays, Muir was lowered alone in a bucket, with a single candle for light, to continue the digging work. At a depth of eighty feet, he passed out for lack of oxygen. The next morning his father lowered him to the bottom again. He didn’t hit water until he was ninety feet down.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xi"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_66182-00014"
    }
  }, [_vm._v("What would now make for a bestselling Pelzerish memoir would, perversely, make Muir into a loafer. For the virtues of diligence, labour and ‘time-hoarding’ that had been drubbed into him during his adolescence – what he came to call his ‘old bondage days’ – would be radically unlearnt during a season of ecstatic idleness in the Californian mountains.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_66182-00015"
    }
  }, [_vm._v("In 1868, aged twenty-nine, Muir arrived in San Francisco. He found the city oppressive and, in a now-legendary exchange, stopped a passer-by to inquire the nearest way out of town. ‘“But where do you want to go?” asked the man to whom I had applied for this important information. “To any place that is wild,” I said. “Yosemite” was the answer.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_66182-00016"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xi"
    }
  }, [_vm._v("And so off Muir went to the Sierra Nevada, the range of mountains which spines central California, and out of which the Yosemite Valley was glacially gouged during the Pleistocene. The following May, he took a job in the Sierra ")]), _c('a', {
    attrs: {
      "id": "pb-rw_xii"
    }
  }, [_vm._v("as a shepherd. His job description was to move a sheep flock ‘gradually higher through the successive forest belts as the snow melted, stopping for a few weeks at the best places we came to’. Nice work if you can get it.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xii"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_66182-00017"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xii"
    }
  }, [_vm._v("Up into the mountains with him that summer Muir carried a journal; bound in green leather. On its inside cover he wrote his name and address: ‘John Muir, Earth-planet, Universe’."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-2-1",
      "id": "num-footnote-2-1-back"
    }
  }, [_vm._v("2")]), _vm._v(" It was a manifesto in miniature: he would try to re-establish a new set of values congruent with the laws of the ‘Universe’ and not with the commandments of thrift and delayed gratification that his father had preached. Muir wished to nest his new self in concentric circles of significance – to link the ego and the world in reciprocal ways.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_66182-00018"
    }
  }, [_c('i', [_vm._v("My First Summer in the Sierra")]), _vm._v(" (1911), published over forty years later and adapted from the journal, is Muir’s account of those mountain-months – days spent exploring, sleeping out, botanising, climbing – and it is his finest single work. Reading the book now, you are rushed back to that joyous season, and to Muir’s drastic re-imagining of himself – wriggling his soul out of the straitjacket into which it had been lashed by his father. Here is his entry for June 6:")]), _vm._v(" "), _c('div', {
    staticClass: "block extract",
    attrs: {
      "id": "rw-block-extract_66182-00001"
    }
  }, [_c('p', {
    staticClass: "fp"
  }, [_vm._v("We are now in the mountains and they are in us … making every nerve quiver, filling every pore and cell of us. Our flesh-and-bone tabernacle seems transparent as glass to the beauty about us, as if truly an inseparable  part of it, thrilling with the air and trees, streams and rocks, in the waves of the sun, – a part of all nature, neither old nor young, sick nor well, but immortal. How glorious a conversion, so complete and wholesome it is. In this newness of life we seem to have been so always.")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_66182-00003"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xiii"
    }
  }, [_vm._v("Muir’s pronouns tell the story. ‘I’ has become ‘we’: the monad of the Presbyterian soul has dissolved into the plurality of the pantheist’s. And his body has become a medium through which the world could quiver itself. What we see at work here, too, is ‘sympathy’ in its strongest nineteenth-century form – not feeling sorry for someone or something, or even feeling like them, but actually being them. The distance of simile has been abolished; Muir has become the mountains, and they have become him. He has shucked off the anthropocentrism of Calvinism, and escaped the windless solitude of the sealed self.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xiii"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_66182-00020"
    }
  }, [_c('i', [_vm._v("My First Summer")]), _vm._v(" teems with passages like this, where Muir melts into his environment. His experiences of rapture were close to the classical Greek concept of ‘metempsychosis’ – the transmigration of the spirit – or, to give it its beautiful German name, "), _c('i', [_vm._v("Seelenwanderung")]), _vm._v(": ‘soul-wandering’. ‘The mtns. are getting back into my blood’, reads a journal entry from July. ‘One’s body seems homogeneous throughout, sound as a crystal’, he records in another. Again and again, the outer moves inwards, and the inner outwards, until such distinctions of perimeter almost cease to make sense.")])]), _c('p', {
    attrs: {
      "id": "rw-p_66182-00021"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xiii"
    }
  }, [_vm._v("No one else, save perhaps the British nature-writer and mystic Richard Jefferies, has felt or written about landscape with this degree of radicalism, this totality of self-immersion. Muir’s prose is sloshy with love for his new world, and its ")]), _c('a', {
    attrs: {
      "id": "pb-rw_xiv"
    }
  }, [_vm._v("glorious effect on him. When writing letters he often didn’t finish words, for he composed in a sort of sprint-telegraphese, born of the necessity to get his joy – which was always dashing ahead of his pen – down.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xiv"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_66182-00022"
    }
  }, [_vm._v("It is the totality of Muir’s conversion that so appeals. "), _c('i', [_vm._v("My")]), _vm._v(" "), _c('i', [_vm._v("First Summer")]), _vm._v(", dense as it is with specific joys, also has the simple form of a parable. Muir ascended to the mountains, and was anointed. In the fastnesses of the Sierra, the scales fell from his eyes. He knew himself that the turn had been total. ‘How glorious a conversion, so complete and wholesome it is, scarce memory enough of old bondage days left as a standpoint to view it from! … In this newness of life we seem to have been so always.’ For nearly a century, counter-culturalists looking to exemplify the possibility of self-recreation, or environmentalists looking for proof of what nature can do to a person, have taken Muir’s experience in Yosemite as their sacred text.")])]), _c('p', {
    attrs: {
      "id": "rw-p_66182-00023"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xiv"
    }
  }, [_vm._v("Muir’s collected writings, most of which are set in the Californian mountains, comprise one of the greatest canticles for the wild ever written. Lyricism is a function of precision, and Muir could be unforgettably precise when writing about landscape. He notes the ‘heavy masonry’ of the Sierra range. He writes of the ‘wind-history of trees’: the ways the screws and gyres of trunks and branches archived weather patterns. He walks across ‘a field of snow as trackless as the sky’. He exults in ‘the wild gala-day of the north wind’. He describes squirrels in their pines, ‘fiery, peppery, full of brag and fight and show, with movements so quick and keen they almost sting the onlooker’. He follows a ‘fat, pollen-dusted’ bumble bee as it ‘rumbled among the flowers’. He recalls a campfire, ")]), _c('a', {
    attrs: {
      "id": "pb-rw_xv"
    }
  }, [_vm._v("‘heaped high with rosiny logs and branches’, as ‘blazing like a sunrise’. "), _c('i', [_vm._v("Blazing like a sunrise")]), _vm._v(" – brilliant, because of course a woodfire is a sunrise of sorts, for the energy released from the timber as flame has been – Muir’s words – ‘slowly sifted from the sunbeams of centuries of summers’.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xv"
    }
  }), _c('p', {
    attrs: {
      "id": "rw-p_66182-00024"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xv"
    }
  }, [_vm._v("Muir’s intrepidity is also distinctive. He was a true adventurer. Consider Thoreau, camped out in his cabin a mile or so from the railway tracks in the Maine woods and calling it ‘wildness’, or Emerson, whose most famous natural epiphany occurred while he was crossing Boston Common between breakfast and lunch."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-3-2",
      "id": "num-footnote-3-2-back"
    }
  }, [_vm._v("3")]), _vm._v(" And then think, by contrast, of Muir, creeping by finger-and toe-tip up steep ice-polished rock in the Sierra, risking his life in order to ‘feel how a glacier felt’.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_66182-00025"
    }
  }, [_vm._v("The novelist Iain Banks once speculated on the leisure activities of the future. They would include, he proposed, lava-rafting and avalanche-surfing. He should have read Muir who, a hundred years earlier, was already inhabiting Banks’s alternative future. In 1873, Muir surfed his first avalanche:")]), _vm._v(" "), _c('div', {
    staticClass: "block extract",
    attrs: {
      "id": "rw-block-extract_66182-00002"
    }
  }, [_c('p', {
    staticClass: "fp"
  }, [_vm._v("I was swished down to the foot of the cañon as if by enchantment. The wallowing ascent had taken nearly all day, the descent only about a minute. When the avalanche started I threw myself on my back and spread my arms to try to keep from sinking. Fortunately, though the grade of the cañon is very steep, it is not interrupted by precipices large enough to cause outbounding or free-plunging. On no part of the rush was I buried. I was only moderately imbedded on the surface or at times a little below it, and covered with a veil of back-streaming dust particles; and as the whole mass beneath and about me joined in the flight there was no friction, though I was tossed here and there and lurched from side to side. When the avalanche swedged and came to rest I found myself on top of the crumpled pile without bruise or scar. This was a fine experience. Hawthorne says somewhere that steam has spiritualised travel; though unspiritual smells, smoke, etc., still attend steam travel. This flight in what might be called a milky way of snow-stars was the most spiritual and exhilarating of all the modes of motion I have ever experienced!")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_66182-00004"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  }, [_vm._v("There is so much to admire here, whether it is that ‘veil of back-streaming dust particles’, or that ‘milky way of snow- stars’, or that trio of strange verbs – ‘to outbound’, ‘to free-plunge’ and ‘to swedge’: typically Muirish neologisms for actions. What might, in the hands of another writer, have become a raucously self-vaunting anecdote of a life nearly lost – the prose equivalent of slamming a drained beer glass down on a table – is for Muir an experience midway between scientific experiment and religious epiphany.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_66182-00027"
    }
  }, [_vm._v("Muir’s writing is filled with such moments of ecstatic transport. When an earthquake strikes the Yosemite Valley at night in March 1872, he is woken by the shaking:")])]), _c('div', {
    staticClass: "block extract",
    attrs: {
      "id": "rw-block-extract_66182-00003"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  }), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xvi"
    }
  }, [_vm._v("The strange, wild thrilling motion and rumbling could not be mistaken, and I ran out of my cabin, near the Sentinel Rock, both glad and frightened, shouting, ‘A noble earthquake!’ feeling sure I was going to learn ")]), _c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  }, [_vm._v("something. The shocks were so violent and varied, and succeeded one another so closely, one had to balance in walking as if on the deck of a ship among the waves, and it seemed impossible the high cliffs should escape being shattered.")])])]), _c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  }, [_c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_66182-00005"
    }
  }, [_vm._v("Another year, when a big winter storm blows in, Muir decides it will be dangerous to remain indoors, so walks off into the forest – but of course! – and clambers to the top of a hundred-foot Douglas Spruce: ")]), _vm._v(" "), _c('div', {
    staticClass: "block extract",
    attrs: {
      "id": "rw-block-extract_66182-00004"
    }
  }, [_c('p', {
    staticClass: "fp"
  }, [_vm._v("In its widest sweeps my tree-top described an arc of from twenty to thirty degrees, but I felt sure of its elastic temper, having seen others of the same species still more severely tried – bent almost to the ground indeed, in heavy snows – without breaking a fibre. I was therefore safe, and free to take the wind into my pulses and enjoy the excited forest from my superb outlook [ … ] The Silver Pines were the most impressively beautiful of all. Colossal spires 200 feet in height waved like supple goldenrods chanting and bowing low as if in worship, while the whole mass of their long, tremulous foliage was kindled into one continuous blaze of white sun-fire.")])])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_66182-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xvii"
    }
  }, [_vm._v("On another occasion Muir tracked the Yosemite Creek to the edge of an escarpment, where it falls half a mile ‘in showy foam to another world’. Keen to hear ‘the death song’ of the Creek in its plummet, he edged down onto a ‘narrow shelf about three inches wide on the very brink, just wide enough for a rest for one’s heels’. From there, soaked by spray, he ‘obtained a ")]), _c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  }, [_vm._v("perfectly free view down into the heart of the snowy, chanting throng of comet-like streamers into which the body of the fall soon separates’.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_66182-00028"
    }
  }, [_vm._v("There is nothing lazy about Muir. Reading him, you feel invulnerable. He gives you seven-league boots. He climbs high mountains in a single paragraph. Rock-fall, blizzard and avalanche cannot harm him. Even his metabolism is apparently superhuman – when he goes off to climb a big peak, he typically ‘fastens a hard, durable crust to my belt by way of provision in case I should be compelled to pass a night on the mountain-top’.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_66182-00002"
    }
  }, [_c('p', {
    staticClass: "fp"
  })])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_66182-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xviii"
    }
  }, [_vm._v("There is a great deal to admire about Muir, then, but he was also not without his faults – both ethically and stylistically – and these faults must be faced up to. So let me number and name them. First of all, Muir can show the kind of misanthropy that gets environmentalism a bad name. He loathed the white American tourists who had been coming to the valley for years before his ‘first summer’ there. ‘The Valley is full of people,’ he wrote, ‘but they do not annoy me. I revolve in pathless places and in higher rocks than the "), _c('i', [_vm._v("world")]), _vm._v(" and his ribbony wife can reach.’ Anyone who declares their lack of annoyance is usually annoyed and, indeed, Muir elsewhere rants about the ‘moiling, squirming, fog-breathing public’, the ‘human stuff ’ which ‘poured into the Valley’, a ‘harmless scum’, made up of mindless men practising a ‘blank fleshly apathy’. Here again – and it is a problem that has dogged the Sierra Club’s conservation efforts since its inception – we hear the voice of the human-hating wild walker, the elitist ecologist: only those who look properly, only those who can ")]), _c('a', {
    attrs: {
      "id": "pb-rw_xix"
    }
  }, [_vm._v("apprehend nature’s magic, should be allowed into these places, claims this voice.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xix"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_66182-00029"
    }
  }, [_vm._v("Then there is Muir’s attitude to Native Americans, which is often used as a stick with which to beat him. To be sure, the passages in "), _c('i', [_vm._v("My First Summer")]), _vm._v(" concerning the Digger Indians of California now make for uneasy reading. Muir refers to the Diggers as ‘dirty’, ‘superstitious’, ‘deadly’, ‘quarrelsome as jays’, and ‘wife-stealing’. Above all, dirty: ‘The worst thing about them is their uncleanliness’ (Muir had a curious preoccupation with hygiene). Nor does he sufficiently acknowledge that Native Americans had been moving through and living among the ‘love-monument mountains’ of Yosemite for centuries before Muir arrived there – until, indeed, in 1851, the state of California forcibly relocated the Native Americans to reservations, in order to allow non-indigenous miners uncompromised access to the area. The Yosemite that Muir experienced seemed in part so wild because its previous inhabitants had been evicted from it. Like regions of Western Ireland (depopulated by the Famine) and Highland Scotland (depopulated by the Clearances), Yosemite was not empty, but emptied out. Muir did not see this clearly enough.")])]), _c('p', {
    attrs: {
      "id": "rw-p_66182-00030"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xix"
    }
  }, [_vm._v("However, as Richard Fleck has observed, Muir also described Indian nut feasts as among the most ‘joyous’ events he had ever witnessed, and once declared his sympathy for the Chief Tenaya, the chief of the displaced Ahwahneechee."), _c('span', {
    staticClass: "ref-footnote"
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-4-3",
      "id": "num-footnote-4-3-back"
    }
  }, [_vm._v("4")]), _vm._v(" ‘Perhaps if I knew them [Native Americans] better, I should like them better’, he wrote in "), _c('i', [_vm._v("My First Summer")]), _vm._v(", and it is to Muir’s credit that he did come to know them better: much later in his life he would spend time living among various Thlinkit tribes of Alaska – the Chilcats, the Hoonas and the Takus – and subsequently became a significant advocate of Native American rights and history.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "rw-indent_66182-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xx"
    }
  }, [_vm._v("Those who dislike Muir often dismiss him as an over-writer. And it’s true that there are times when he becomes just too joyful, too effusive. His prose congeals to an unctuous gumminess, and he sounds like the nature-loving ‘sissy’ Fotherington-Thomas in the "), _c('i', [_vm._v("Molesworth")]), _vm._v(" books. ‘Hello birds, hello trees!’, cries Fotherington-Thomas, ‘Nature alone is beautiful!’. ‘How fine the weather is!’ cries Muir. ‘Nothing more celestial can I conceive! How gently the winds blow! Scarcely can these air-currents be called winds! They seem the very breath of Nature, whispering peace to every living thing!’ Muir could be lampoonably cute. In 1870, when he was first falling in love with the Californian forests, he wrote a letter to a friend. He put his address down as ‘Squirrelville, Sequoia Co., Nut time’. ‘I’m in the woods woods woods,’ the letter began, ‘& they are in "), _c('i', [_vm._v("me-")]), _c('i', [_vm._v("ee-")]), _c('i', [_vm._v("ee")]), _vm._v("’. The boulders of Yosemite, he once remarked, ‘are dear friends, and have warm blood gushing through their granite flesh; and I love them’. They love you too, John.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xx"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_66182-00032"
    }
  }, [_vm._v("Muir’s writing is an irony-free zone. This is no surprise – irony and joy tend to harry each other into powerlessness. But at times, reading Muir, you long for a quick blaze of self-awareness. Thoreau is always bending round and biting his own back, checking himself, laying an ear to his prose to check for pomposity or pretentiousness. Muir never does this. He is completely committed to his tone – and this commitment is the source of both his strength and his weakness as a writer.")])]), _c('p', {
    attrs: {
      "id": "rw-p_66182-00034"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xx"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_xxi"
    }
  }, [_vm._v("It is no surprise to learn that the exclamation mark was Muir’s favourite form of punctuation. E. M. Forster once likened the use of exclamation marks to laughing at one’s own jokes, but nothing so solipsistic is at work with Muir, I think. For him, the exclamation mark was a way of notating rapture. There was never any self-admiration involved in his writing. Not once, in the thousands of pages of his published prose, is the landscape tilted so as flatteringly to reflect Muir’s own image. One of his favourite adjectives was ‘showy’ – the ‘showy purple panicles of grass’, the ‘showy and fragrant rhododendron’ – but he used the word, as he used so much language, in its innocent form: to suggest a gleeful extravagance, rather than an immodesty. His prose is ‘showy’ in the best sense of the word.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xxi"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_66182-00003"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_66182-00008"
    }
  }, [_vm._v("After that magical first summer, Muir stayed in the Valley for six years, leaving its precincts as rarely as possible. ‘As far as I can’, he had written in his journal that first June, ‘I must drift about these love-monument mountains, glad to be a servant of servants in so holy a wilderness.’ So drift he did. He went on the "), _c('i', [_vm._v("dérive")]), _vm._v(": climbing and exploring, walking thousands of miles, discovering living glaciers, mapping the distribution of the giant redwoods, and building up the formidable archive of natural experience which would issue into his prose. Towards the end of that time, too, he launched his writing career with a series of articles called ‘Studies in the Sierra’. It was his writing – mostly published as articles and essays – that would win him such a massive public following, and eventually give him such powerful political leverage.")])]), _c('p', {
    attrs: {
      "id": "rw-p_66182-00035"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxi"
    }
  }, [_vm._v("Shortly before his death, Muir commented to a friend, ‘I ")]), _c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  }, [_vm._v("have lived a bully life. I have done what I set out to do.’ It’s a comment which, in its lovely colloquial firmness, reminds me of Edmund Hillary’s first words on returning from his successful ascent of Mount Everest in 1953. ‘Well George,’ Hillary said to the first man to reach him as he approached the safety of high camp, ‘we knocked the bastard off.’")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_66182-00036"
    }
  }, [_vm._v("Muir did what he set out to do – and more. During the last four decades of his life – the years after he had come down from the mountains – he merged his intuitive and abstract love of wildness with a facility for realpolitik. He learned the need to lobby for the preservation of the landscapes he loved. The two principal results of Muir’s political activities – the Sierra Club and Yosemite National Park – are enduring achievements. Yosemite Park, out of which eventually emerged the global National Park movement, was born not out of a soggy aesthetic conviction that trees and mountains were nice to look at, but out of Muir’s fierce belief that wild places were profoundly edifying both morally and imaginatively.")])]), _c('p', {
    attrs: {
      "id": "rw-p_66182-00037"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxii"
    }
  }, [_vm._v("Less immediately obvious, but perhaps more deeply influential, was the revolution of wilderness sensibility that Muir incited. Prior to Muir, the appreciation of wild landscape was a kind of greatest-hits aesthetic, which prized ‘curiosities’ – hot springs, dramatic escarpments, picture-postcard views – rather than whole areas. Muir, however, introduced the concept of interconnectedness: that, in his words, ‘as soon as we take one thing by itself, we find it hitched to everything in the universe’. Reading "), _c('i', [_vm._v("My First Summer")]), _vm._v(", you see Muir thinking not in terms of hierarchies but in terms of networks. He admires the ‘little water ouzel’ as much as the black bear, and the dwarf pine as much as the giant sequoia. He even ")]), _c('a', {
    attrs: {
      "id": "pb-rw_xxiii"
    }
  }, [_vm._v("writes lovingly of bluebottles – who ‘make all flesh fly’ – for their part in nature’s thriftily recyclical economy. Muir’s natural vision was one of interinanimation: of the relationships between things being as important as the things themselves, of network rather than hierarchy.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xxiii"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_66182-00038"
    }
  }, [_vm._v("Unlike so many eminent Victorians, who survive only as sepia print or guano-streaked statuary, Muir has grown in influence since his death. His insights about wildness have a burry relevance to them; they have become ever more insistently attached to our culture. ‘Thousands of tired, nerve-shaken, over-civilised people are beginning to find out that going to the mountains is going home’, he wrote in 1875, over a century before the boom decades of the outdoor industry, and before a fierce desire for the wild began to express itself in the Western imagination.")])]), _c('p', {
    attrs: {
      "id": "rw-p_66182-00039"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxiii"
    }
  }, [_vm._v("Muir’s achievement was to explain and energise a sense of the spiritual worth of wildness. He asked not what wild places can do "), _c('i', [_vm._v("for")]), _vm._v(" us, but what they can do "), _c('i', [_vm._v("to")]), _vm._v(" us. This is why his fiercely immediate attention to the power of wildness to change us as humans – the power of outer landscapes to reshape for the better our inner territories – is so valuable, and has become so political. More and more of us exist for more and more of the time in worlds which are humanly arranged, themed and controlled. It is easy to forget that there are environments which do not respond to the flick of a switch or the twist of a dial, and which have their own rhythms and orders of existence. Wild places, Muir understood, correct this forgetfulness. By speaking of greater forces than we can possibly invoke, and by confronting us with greater spans of time than we can possibly envisage, they refute our excessive trust in the ")]), _c('a', {
    attrs: {
      "id": "pb-rw_xxiv"
    }
  }, [_vm._v("man-made. They pose profound questions about our durability and the importance of our schemes.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_xxiv"
    }
  }, [_c('p', {
    attrs: {
      "id": "rw-p_66182-00040"
    }
  }, [_vm._v("When I read Muir – as when I go to the mountains or the wilderness – I am astonished again by the simplest transactions of the physical world: a snowflake a millionth of an ounce in weight falling onto one’s outstretched palm; water patiently carving a runnel in a face of granite; the apparently motiveless shift of a stone in a scree-filled gully. To put a hand down and feel the ridges and scores in a rock where a glacier has passed; to hear how a hillside comes alive with moving water after a rain-shower; to see late summer light filling miles of landscape like an inexhaustible liquid; none of these is a trivial experience, and neither is reading Muir’s prose.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_66182-00041"
    }
  }, [_vm._v("Were the world to bankrupt itself of wildness – as it is perfectly capable of doing – the cost would be devastating. One thinks here of Auden’s tersely brilliant observation that ‘a culture is no better than its woods’. The preservation of wild places is as essential to a country’s geography of hope as urban regeneration, and John Muir is one of the finest geographers of hope we could wish for.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_66182-00004"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "rw-p_66182-00042"
    }
  }, [_c('b', [_vm._v("Robert Macfarlane, February 2007")])])]), _c('div', {
    staticClass: "block footnotes"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxiv"
    }
  }), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_xxiv"
    }
  }, [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-1-0"
    }
  })]), _c('a', {
    attrs: {
      "href": "#/#num-footnote-1-0-back"
    }
  }, [_vm._v("1")]), _vm._v(" Wallace Stegner, ‘Wilderness Idea’, in "), _c('em', [_vm._v("The Sound of Mountain Water")]), _vm._v(" (1969)")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-2-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-2-1-back"
    }
  }, [_vm._v("2")])]), _vm._v(" One thinks of the young Stephen Dedalus, in Joyce’s "), _c('em', [_vm._v("A Portrait of the Artist As A Young Man")]), _vm._v(" (1914), who would scribble his location on the flyleaf of his geography book: ‘Stephen Dedalus; Class of Elements; Clongowes Wood College; County Kildare; Ireland; Europe; The World; The Universe’.")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-3-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-3-2-back"
    }
  }, [_vm._v("3")])]), _vm._v(" Ralph Waldo Emerson, "), _c('em', [_vm._v("Nature; Addresses and Lectures")]), _vm._v(" (1836)")]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    staticClass: "num-footnote",
    attrs: {
      "id": "num-footnote-4-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/#num-footnote-4-3-back"
    }
  }, [_vm._v("4")])]), _vm._v(" Richard Fleck, Henry "), _c('em', [_vm._v("Thoreau and John Muir Among The Indians")]), _vm._v(" (1985)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c1d704d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847674470_introduction.vue
// module id = 66
// module chunks = 0